import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as UISelectors, actions as UIActions } from 'data/ui'

import { withNoteMetaPanelControls } from 'routes/utils/withNoteMetaPanelControls'

import IconButton from 'components/Utils/IconButton'
import { OutlineIcon } from 'components/Utils/Icons'

export const META_PANEL_OUTLINE_CONTAINER = 'META_PANEL_OUTLINE_CONTAINER'

const MIN_WINDOW_WIDTH_TO_DISPLAY_COMMENTS = 1000

export class OutlineButton extends Component {
  render() {
    const { isOutlineOpen, isDetachedMode, toggleOutline } = this.props
    return (
      <IconButton
        style={{ marginBottom: 2 }}
        tooltip={
          isOutlineOpen ? 'Hide table of contents' : 'Show table of contents'
        }
        tooltipPosition="left"
        onClick={() => {
          if (
            isDetachedMode &&
            window.outerWidth < MIN_WINDOW_WIDTH_TO_DISPLAY_COMMENTS &&
            !isOutlineOpen
          ) {
            window.resizeTo(1000, window.outerHeight)
          }

          toggleOutline()
        }}
      >
        <OutlineIcon size={16} />
      </IconButton>
    )
  }
}

export default compose(
  withNoteMetaPanelControls,
  connect(
    (state, { noteId }) => ({
      isDetachedMode: UISelectors.isDetachedModeEnabled(state),
    }),
    {
      toggleFocusMode: UIActions.toggleFocusMode,
    }
  )
)(OutlineButton)
